import {
  NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID,
  NATIVE_TOKEN_ADDRESS_FOR_BLOCK_EXPLORER_BY_CHAIN_ID,
} from '../constants/addresses';
import { HYPERCORE_CHAIN_ID, solana, SUPPORTED_CHAINS_BY_CHAIN_ID } from '../constants/chain';

export const getBlockExplorerURL = (chainId: number): string => {
  try {
    // TODO: remove when solana is part of SUPPORTED_CHAINS_BY_CHAIN_ID
    if (chainId == solana.id) {
      return solana.blockExplorers.default.url;
    }
    if (chainId === HYPERCORE_CHAIN_ID) return 'https://app.hyperliquid.xyz/explorer';
    return SUPPORTED_CHAINS_BY_CHAIN_ID[chainId].blockExplorers!.default.url;
  } catch {
    throw new RangeError('Chain is not supported');
  }
};

export const getBlockExplorerTokenURL = (
  chainId: number,
  tokenAddress: string,
): string | undefined => {
  const isNativeToken = NATIVE_TOKEN_ADDRESS_PER_CHAIN_ID[chainId] === tokenAddress;
  if (!isNativeToken) return `${getBlockExplorerURL(chainId)}/token/${tokenAddress}`;

  const nativeTokenAddress = NATIVE_TOKEN_ADDRESS_FOR_BLOCK_EXPLORER_BY_CHAIN_ID[chainId];
  if (!nativeTokenAddress) return;

  return `${getBlockExplorerURL(chainId)}/token/${nativeTokenAddress}`;
};

export const getBlockExplorerTransactionURL = (chainId: number, txHash: string): string =>
  `${getBlockExplorerURL(chainId)}/tx/${txHash}`;
